module.exports = __webpack_public_path__ + "img/unionpay.20f636ec.svg";